import React, { useEffect,useState } from 'react';
import './privada.css';
import { datos } from '../../json/privada';

const Privada = () => {
    const [filteredList, setFilteredList] = new useState(datos);

    const filterBySearch = (event) => {
        // Access input value
        const query = event.target.value;
        // Create copy of item list
        var updatedList = [...datos];
        // Include all elements which includes the search query
          updatedList = updatedList.filter((item) => {
          return item.empresa.toLowerCase().indexOf(query.toLowerCase()) !== -1;
        });
        // Trigger render with updated values
        setFilteredList(updatedList);
      };
      
      
    useEffect(() => {
        window.scrollTo(0, 0);
        //setFilteredList(datos);
      }, []);

      
  return (
    <div className='container transparencia-container'>
        <div className='row'>
            <div className='col_12'>
                <div className='transparencia_title'>
                    <h3 className='title-silver'>Prestadores de Servicios de Seguridad Privada en Hidalgo</h3>
                    <hr className='hr-gob'/>
                </div>
                <div className='texto_privada'>
                    <p>
                    Consulta el directorio de empresas autorizadas por la Unidad de Registro y Supervisión de Seguridad Privada de la Secretaría de Seguridad Pública de Hidalgo. Esta dependencia estatal es la facultada para otorgar la autorización para el funcionamiento y operación de los servicios de seguridad privada en la entidad.
                    </p>
                    <br/>
                        <h3>Modalidades de los Servicios:</h3>
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item">Seguridad privada y protección personal</li>
                            <li className="list-group-item">Vigilancia y protección de bienes</li>
                            <li className="list-group-item">Custodia, traslado y vigilancia de bienes o valores</li>
                            <li className="list-group-item">Servicio de alarmas y de monitoreo electrónico</li>
                        </ul>
                </div>
            </div>
        </div>
        
        <div className='row pt-30'>
            <div >
                        <img src="../../assets/imgs/SegPriv1.jpg"  width="100%" />
            </div>

            <div className="steps-row">
                  <div className="text-center">
                    <div className="input-group mb-3">
                        <input id="search-box" type="search" className="form-control" placeholder="¿Cómo se llama la empresa que buscas?"  onChange={filterBySearch} />
                       <span className="input-group-text" id="inputGroup-sizing-sm">Busqueda</span>
                     </div>
    
                     <div className="list-group" id="resultados">
                     <table className="table table-striped mitabla">
                                                <thead>
                                                    <tr>
                                                    <th scope="col">LOGOTIPO</th>
                                                    <th scope="col">EMPRESA</th>
                                                    <th scope="col">REPRESENTANTE LEGAL</th>
                                                    <th scope="col">TELÉFONO</th>
                                                    
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                filteredList.map((dato, index) => (
                                                         <tr key={index}>
                                                         <td><img src={dato.imagen} width="60px"/></td>
                                                         <td scope="row">{dato.empresa}</td>
                                                         <td>{dato.representante}</td>
                                                         <td>{dato.contacto1}</td>
                                                         
                                                       </tr>
                                                    ))
                                                }


                                                </tbody>
                                                </table>
                     </div>
    
                  </div>
              </div>

      

               <div>
                  
                </div>
        
        </div>

        <div className='row'>
            <div className='privada_title'>
                    <h3 className='title-silver'>Contacta a la Unidad de Registro y Supervisión de Seguridad Privada de la Secretaría de Seguridad Pública de Hidalgo.</h3>
                    <hr className='hr-gob'/>
            </div>
            <br/>
                <div>
                  <p className='fontLarge'><a href="tel:+527714731288" ><i className="fas fa-phone" ></i><strong>  Teléfono:</strong> 771 473 1288 </a></p>
                  <br/>

                  <p className='fontLarge'><a href="mailto:prestadores.seguridad.privada@hidalgo.gob.mx" ><i className="fas fa-envelope" ></i><strong>  Correo:</strong> <br/>prestadores.seguridad.privada@hidalgo.gob.mx </a></p>

                  <br/>

                  <p className='fontLarge'><a href="https://goo.gl/maps/ow3zH9yeHiXeLnVr6">
                    <i className="fas fa-home" ></i>
                    <strong>  Dirección:</strong><br/>   Bulevar Luis Donaldo Colosio S/N,<br/>   Fraccionamiento Colosio II, <br/>   Municipio de Pachuca, Hidalgo, <br/>   C.P. 42039 </a></p>
                </div>


        </div>


        
    </div>
  )
}

export default Privada